import { isEmpty } from '@webtrader/core/validators';

import { companyService } from '../services/company';
import geolocationService from '../services/geolocation/service';
import { checkIsNative } from '../validators/device';
import { getQueryLangFromTLang } from './i18n';

export const formatUrl = (url?: string) => {
  if (!url || isEmpty(url)) {
    return undefined;
  }

  const isHttpProtocolPresent = url.includes('https:') || url.includes('http:');

  if (isHttpProtocolPresent) {
    return url;
  } else {
    return 'https://' + url;
  }
};

export const normaliseMarketingUrl = (rawUrl?: string) => {
  if (!rawUrl || isEmpty(rawUrl)) {
    return undefined;
  }

  return formatUrl(rawUrl);
};

export const getLocalisedUrl = (url?: string | null | undefined): string | undefined => {
  if (!url) {
    return undefined;
  }

  const lang = getQueryLangFromTLang();
  try {
    const urlObj = new URL(url);
    return urlObj.toString().replace('%7B%7Blanguage%7D%7D', lang); // replace the encoded url tags
  } catch (_err) {
    return undefined;
  }
};

/**
 * Formats a URL for mobile/mobileo-web usage by:
 * 1. Replacing {{language}} placeholder with current language
 * 2. Applying tenant-specific domain replacements (e.g., Hantec fallback)
 */
export const formatMobileUrl = (url?: string | null | undefined): string | undefined => {
  const isNative = checkIsNative();
  if (!url) {
    return undefined;
  }

  // Step 1: Apply localization (replace {{language}} placeholder)
  let formattedUrl = getLocalisedUrl(url);

  // Step 2: Apply tenant-specific domain replacement if applicable
  if (companyService.getTenantId() === 'hantec') {
    // Mobile web handle by {{domain}} --> BE will auto format the domain according to the main domain
    // Eg. https://webtrader.hmarkets.cn -> https://hmarkets.cn
    if (isNative && formattedUrl?.includes('hmarkets.com') && geolocationService.getIsChina()) {
      formattedUrl = formattedUrl?.replace('hmarkets.com', 'hmarkets.cn');
    }
  }

  return formattedUrl;
};
